import { useMutation } from "react-query";
import api from "../../client";
import { FileTypeEnum } from "../../types/files";

const uploadProfilePictureRequest = async (
  profileId: string,
  payload: UploadPeopleProfilePicturePayload,
): Promise<UploadPeopleProfilePictureResponseData> => {
  const formdata: FormData = new FormData();
  formdata.append("profile_picture", payload.picture);

  const { data } = await api.post<UploadPeopleProfilePictureResponseData>(
    `/profile/${profileId}/profile-image`,
    formdata,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return data;
};

export interface UploadPeopleProfilePicturePayload {
  picture: File;
}

export interface ProfilePictureDetail {
  id: string;
  name: string;
  path: string;
  type: FileTypeEnum;
}

export interface UploadPeopleProfilePictureResponseData {
  data: ProfilePictureDetail;
}

export const useUploadProfilePicture = () => {
  return useMutation({
    mutationFn: ({
      profileId,
      ...payload
    }: UploadPeopleProfilePicturePayload & { profileId: string }) =>
      uploadProfilePictureRequest(profileId, payload),
  });
};
